module.exports = __webpack_public_path__ + "assets/images/cancel-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/cancel-on.png
// module id = 1493
// module chunks = 1